'use client';

import { createContext } from 'react';

export type BreadcrumbItem = {
  label: string;
  href?: string;
};

export type HeaderAction = React.ReactNode;

type HeaderContextValue = {
  breadcrumbs: BreadcrumbItem[];
  setBreadcrumbs: (items: BreadcrumbItem[]) => void;
  actions: HeaderAction[];
  setActions: (actions: HeaderAction[]) => void;
};

export const HeaderContext = createContext<HeaderContextValue | null>(null);
